import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FreudButtonModule, FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { SupersetEmbedComponent } from './superset-embed.component';

@NgModule({
	declarations: [SupersetEmbedComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudButtonModule,
		FormsModule,
		ReactiveFormsModule,
		FreudLoaderModule,
	],
	exports: [SupersetEmbedComponent],
})
export class SupersetEmbedModule {}
